<div class="toast-area" [@stack]="toasts()?.length ?? 0">
	@if (toasts() && toasts()!.length > 0) {
	@for (toast of toasts()!; track toast.id) {
	<app-toast class="toast-item" [id]="toast.id!" [status]="toast.status ?? 'neutral'">
		<ng-container
			*ngComponentOutlet="getMatchingComponent(toast.kind); inputs: getMatchingInputs(toast.kind, toast)" />
	</app-toast>
	}
	}
</div>